import { PROFILE_FETCH,SET_RICHMENU } from '../actions/types';

export default function (state = [], action) {
  switch (action.type) {
    case PROFILE_FETCH:
      return action.payload;
    default:
      return state;
  }
}

export function setRichMenu(state = [], action) {
  switch (action.type) {
    case SET_RICHMENU:
      return action.payload;
    default:
      return state;
  }
}
